<template>
  <el-config-provider :locale="locale">
    <el-image class="left-aligned-image" style="width: 120px; height: 60px; position: absolute; top: 0px; left: 60px;" src="https://srb-data.oss-cn-beijing.aliyuncs.com/issue/2023/11/28/compass1.png/a32f9f58-bb14-4972-9b68-09b32cbafbbc"></el-image>
  <h3 style="width:100%; height:60px; position:absolute; top:20px; left: 0;">{{ this.$t('home.issue', { msg: 'home.issue' }) }}</h3>
  <!-- <vue-particles id="particles-js" color="#8EC5FC" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle" :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push"></vue-particles> -->
  <el-container style="width:100%; position:absolute;  top:60px; left: 0; bottom:0; border: 0 solid #eee">
    <el-aside width="260px" style="background-color: rgb(238, 241, 246)">
      <el-menu :default-openeds="['1']"
                :default-active="this.$route.path"
                router
                style="background-color: rgb(238, 241, 246); overflow-x: hidden;">

        <el-sub-menu index="1">
          <template #title><i class="el-icon-document"></i>{{ $t('home.menu.issueManage', { msg: 'home.menu.issueManage' }) }}</template>
            <el-menu-item index="/issue" :title="$t('home.menu.issueView', { msg: 'home.menu.issueView' })">{{ $t('home.menu.issueView', { msg: 'home.menu.issueView' }) }}</el-menu-item>
            <el-menu-item index="/exportissue" :title="$t('home.menu.issueExport', { msg: 'home.menu.issueExport' })" v-if="!username.includes('zhumin')" >{{ $t('home.menu.issueExport', { msg: 'home.menu.issueExport' }) }}</el-menu-item>
            <el-menu-item index="/addtype" :title="$t('home.menu.newType', { msg: 'home.menu.newType' })">{{ $t('home.menu.newType', { msg: 'home.menu.newType' }) }}</el-menu-item>
            <el-menu-item index="/showcharger" :title="$t('home.menu.issueCharger', { msg: 'home.menu.issueCharger' })" v-if="role.includes('超级管理员')">{{ $t('home.menu.issueCharger', { msg: 'home.menu.issueCharger' }) }}</el-menu-item>
            <!-- <el-menu-item index="/cusstatus" title="客户化问题类型">客户化问题类型</el-menu-item> -->
        </el-sub-menu>

        <el-sub-menu index="2">
          <template #title><i class="el-icon-s-platform"></i>{{ $t('home.menu.kb', { msg: 'home.menu.kb' }) }}</template>
          <el-menu-item index="/kbinfo" :title="$t('home.menu.kbInfo', { msg: 'home.menu.kbInfo' })">{{ $t('home.menu.kbInfo', { msg: 'home.menu.kbInfo' }) }}</el-menu-item>
          <el-menu-item index="/newkb" :title="$t('kbinfo.newKb', { msg: 'kbinfo.newKb' })">{{ $t('kbinfo.newKb', { msg: 'kbinfo.newKb' }) }}</el-menu-item>
          <el-menu-item index="/kbreview" :title="$t('home.menu.kbM', { msg: 'home.menu.kbM' })" v-if="role.includes('超级管理员') || isPass === 1"  >{{ $t('home.menu.kbM', { msg: 'home.menu.kbM' }) }}</el-menu-item>
          <el-menu-item index="/showvaluechain" :title="$t('home.menu.vc', { msg: 'home.menu.vc' })">{{ $t('home.menu.vc', { msg: 'home.menu.vc' }) }}</el-menu-item>
          <el-menu-item index="/DTLevel" :title="$t('home.menu.pd', { msg: 'home.menu.pd' })">{{ $t('home.menu.pd', { msg: 'home.menu.pd' }) }}</el-menu-item>
          <el-menu-item index="/knowledgetype" :title="$t('home.menu.kbType', { msg: 'home.menu.kbType' })">{{ $t('home.menu.kbType', { msg: 'home.menu.kbType' }) }}</el-menu-item>
        </el-sub-menu>

        <!-- <el-sub-menu index="7" v-if="role.includes('管理员')">
          <template #title><i class="el-icon-s-opportunity"></i>{{ $t('home.menu.expert', { msg: 'home.menu.expert' }) }}</template>
          <el-menu-item index="/expertreview" :title="$t('home.menu.expertreview', { msg: 'home.menu.expertreview' })" v-if="role.includes('管理员')">{{ $t('home.menu.expertreview', { msg: 'home.menu.expertreview' }) }}</el-menu-item>
          <el-menu-item index="/expertall" :title="$t('home.menu.expertall', { msg: 'home.menu.expertall' })" v-if="role.includes('管理员')">{{ $t('home.menu.expertall', { msg: 'home.menu.expertall' }) }}</el-menu-item>

        </el-sub-menu> -->
        <el-sub-menu index="7" v-if="role.includes('管理员')">
        <template #title>
          <svg t="1720148456971" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1488" width="20" height="20">
            <path d="M792.00256 541.3888a53.18656 53.18656 0 1 0 70.106453-50.373973V274.592427l16.837974-8.43776a19.15904 19.15904 0 0 0-1.102507-34.816L477.2864 62.767787a19.3536 19.3536 0 0 0-17.281707 1.225386L134.120107 257.706667a19.2 19.2 0 0 0 3.474773 34.6112l144.090453 50.517333a246.15936 246.15936 0 0 0 125.467307 323.976533A360.168107 360.168107 0 0 0 155.845973 939.008a18.244267 18.244267 0 0 0 14.22336 21.538133 20.176213 20.176213 0 0 0 3.70688 0.361814 18.3296 18.3296 0 0 0 17.88928-14.547627 323.242667 323.242667 0 0 1 315.76064-257.30048c151.3472 0 283.958613 110.830933 315.29984 258.658987a18.466133 18.466133 0 0 0 21.67808 14.093653 18.2784 18.2784 0 0 0 14.097067-21.67808 366.506667 366.506667 0 0 0-251.6992-273.097387 246.142293 246.142293 0 0 0 124.613973-326.980266l96.768-48.520534v199.49568a53.248 53.248 0 0 0-36.181333 50.373974z m-284.822187 110.114133a209.640107 209.640107 0 0 1-147.715413-358.505813 226.54976 226.54976 0 0 1 295.051947-0.37888 209.62304 209.62304 0 0 1-147.336534 358.884693zM717.824 303.991467a266.73152 266.73152 0 0 0-62.737067-58.975574 245.76 245.76 0 0 0-296.328533 0.365227A267.10016 267.10016 0 0 0 294.570667 306.705067L189.04064 269.728427l282.313387-167.79264L824.5248 250.5728z m127.34464 256.682666a19.298987 19.298987 0 1 1 13.653333-5.635413 19.288747 19.288747 0 0 1-13.653333 5.635413z m0 0" p-id="1489" fill="#8a8a8a"></path>
          </svg>
          {{ $t('home.menu.expert', { msg: 'home.menu.expert' }) }}
        </template>
        <el-menu-item index="/expertreview" :title="$t('home.menu.expertreview', { msg: 'home.menu.expertreview' })" v-if="role.includes('管理员')">
          {{ $t('home.menu.expertreview', { msg: 'home.menu.expertreview' }) }}
        </el-menu-item>
        <el-menu-item index="/expertall" :title="$t('home.menu.expertall', { msg: 'home.menu.expertall' })" v-if="role.includes('管理员')">
          {{ $t('home.menu.expertall', { msg: 'home.menu.expertall' }) }}
        </el-menu-item>
      </el-sub-menu>



        <el-sub-menu index="3" v-if="role.includes('管理员')">
          <template #title><i class="el-icon-user"></i>{{ $t('home.menu.cm', { msg: 'home.menu.cm' }) }}</template>
          <el-menu-item index="/usercompany" :title="$t('home.menu.mcm', { msg: 'home.menu.mcm' })" v-if="role.includes('超级管理员')">{{ $t('home.menu.mcm', { msg: 'home.menu.mcm' }) }}</el-menu-item>
          <el-menu-item index="/outsider" :title="$t('home.menu.outsider', { msg: 'home.menu.outsider' })" v-if="role.includes('超级管理员')">{{ $t('home.menu.outsider', { msg: 'home.menu.outsider' }) }}</el-menu-item>
          <el-menu-item index="/usershow" :title="$t('home.menu.muser', { msg: 'home.menu.muser' })" v-if="role.includes('管理员')">{{ $t('home.menu.muser', { msg: 'home.menu.muser' }) }}</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="4" v-if="role.includes('超级管理员')">
          <template #title><i class="el-icon-crop"></i>{{ $t('home.menu.agentM', { msg: 'home.menu.agentM' }) }}</template>
          <el-menu-item index="/agent" :title="$t('home.menu.magent', { msg: 'home.menu.magent' })">{{ $t('home.menu.magent', { msg: 'home.menu.magent' }) }}</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="6">
          <template #title><i class="el-icon-s-data"></i>{{ $t('home.menu.dataPlatform', { msg: 'home.menu.dataPlatform' }) }}</template>
          <el-sub-menu index="7">
            <template #title>{{ $t('home.menu.dataOpr', { msg: 'home.menu.dataOpr' }) }}</template>
           <el-menu-item @click="this.$message.error(this.$t('common.noAuth', { msg: 'common.noAuth' }))" :title="$t('home.menu.dataImport', { msg: 'home.menu.dataImport' })">{{ $t('home.menu.dataImport', { msg: 'home.menu.dataImport' }) }}</el-menu-item>
           <el-menu-item @click="this.$message.error(this.$t('common.noAuth', { msg: 'common.noAuth' }))" :title="$t('home.menu.dataExport', { msg: 'home.menu.dataExport' })">{{ $t('home.menu.dataExport', { msg: 'home.menu.dataExport' }) }}</el-menu-item>
           <el-menu-item @click="this.$message.error(this.$t('common.noAuth', { msg: 'common.noAuth' }))" :title="$t('home.menu.EDI', { msg: 'home.menu.EDI' })">{{ $t('home.menu.EDI', { msg: 'home.menu.EDI' }) }}</el-menu-item>
           <el-menu-item @click="this.$message.error(this.$t('common.noAuth', { msg: 'common.noAuth' }))" :title="$t('home.menu.BOD', { msg: 'home.menu.BOD' })">{{ $t('home.menu.BOD', { msg: 'home.menu.BOD' }) }}</el-menu-item>
          </el-sub-menu>
          <el-menu-item @click="this.$message.error(this.$t('common.noAuth', { msg: 'common.noAuth' }))" :title="$t('home.menu.dataMig', { msg: 'home.menu.dataMig' })">{{ $t('home.menu.dataMig', { msg: 'home.menu.dataMig' }) }}</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="5" v-if="role.includes('超级管理员')">
          <template #title><i class="el-icon-setting"></i>{{ $t('home.menu.sysM', { msg: 'home.menu.sysM' }) }}</template>
          <el-menu-item index="/watcher" :title="$t('home.menu.om', { msg: 'home.menu.om' })">{{ $t('home.menu.om', { msg: 'home.menu.om' }) }}</el-menu-item>
        <!--  <el-menu-item index="/fileshow" :title="$t('home.menu.fm', { msg: 'home.menu.fm' })">{{ $t('home.menu.fm', { msg: 'home.menu.fm' }) }}</el-menu-item> -->
        </el-sub-menu>

        <el-sub-menu index="8">
          <template #title><i class="el-icon-s-operation"></i>{{ $t('home.menu.pcb', { msg: 'home.menu.pcb' }) }}</template>
          <el-menu-item index="/material" :title="$t('home.menu.materialm', { msg: 'home.menu.materialm' })">{{ $t('home.menu.materialm', { msg: 'home.menu.materialm' }) }}</el-menu-item>
          <el-menu-item index="/craft" :title="$t('home.menu.craftm', { msg: 'home.menu.craftm' })">{{ $t('home.menu.craftm', { msg: 'home.menu.craftm' }) }}</el-menu-item>
          <el-menu-item index="/purchase" :title="$t('home.menu.purchasem', { msg: 'home.menu.purchasem' })">{{ $t('home.menu.purchasem', { msg: 'home.menu.purchasem' }) }}</el-menu-item>
          <el-menu-item index="/chatAI" :title="$t('home.menu.chatai', { msg: 'home.menu.chatai' })">{{ $t('home.menu.chatai', { msg: 'home.menu.chatai' }) }}</el-menu-item>
        </el-sub-menu>

        <!-- <el-sub-menu index="5" v-if="role.includes('超级管理员')">
          <template #title><i class="el-icon-setting"></i>{{ $t('home.menu.serial', { msg: 'home.menu.serial' }) }}</template>
          <el-menu-item index="/serialnoexport" :title="$t('home.menu.serialReport', { msg: 'home.menu.serialReport' })">{{ $t('home.menu.serialReport', { msg: 'home.menu.serialReport' }) }}</el-menu-item>
        </el-sub-menu> -->

      </el-menu>
    </el-aside>
    <el-container >
      <!-- <el-header style="text-align: right; font-size: 12px">
        <el-image style="width: 100px; height: 60px;" src="https://srb-data.oss-cn-beijing.aliyuncs.com/issue/2023/11/28/compass1.png/a32f9f58-bb14-4972-9b68-09b32cbafbbc"></el-image>
        <el-dropdown @command="handleCommand">
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="个人主页">个人主页</el-dropdown-item>
              <el-dropdown-item command="退出登录">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <span>{{ username }}</span>
      </el-header> -->
        <el-header style="display: flex; justify-content: space-between; align-items: center; font-size: 12px;">
          <div style="display: flex; align-items: center;">
            <!-- <el-text style="margin-right: 10px;" size="large">{{ $t('home.tech', { msg: 'home.tech' }) }}</el-text> -->
            <el-text v-if="this.username != 'admin' && !agentNone" style="margin-right: 10px; line-height: 40px;">{{ $t('home.agent', { msg: 'home.agent' }) }}</el-text>
            <!-- <el-text v-if="this.agentNone">{{ $t('home.agentNone', { msg: 'home.agentNone' }) }}</el-text> -->
            <div v-for="item in agent" :key="item.name" style="display: flex; align-items: center; margin-right: 10px;">
              <el-text v-if="this.username !== 'admin'" style="margin-right: 10px;">{{item.name}}</el-text>
              <el-image v-if="this.username !== 'admin'" style="width: 60px; height: 60px; margin-right: 10px;" :src="item.logo"></el-image>
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <!-- <el-dropdown @command="toggle">
              <span class="el-dropdown-link">
                {{ label_language }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="zhCn">简体中文</el-dropdown-item>
                  <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown> -->

            <el-dropdown style="margin-left: 20px;" @command="handleCommand">
              <i class="el-icon-setting" style="margin-right: 5px"></i>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="个人主页">{{ $t('home.homePage', { msg: 'home.homePage' }) }}</el-dropdown-item>
                  <!-- <el-dropdown-item command="申请用户">{{ $t('home.applyoutsider', { msg: 'home.applyoutsider' }) }}</el-dropdown-item> -->
                  <el-dropdown-item command="退出登录">{{ $t('home.signOut', { msg: 'home.signOut' }) }}</el-dropdown-item>         
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <span style="margin-left: 5px;">{{ username }}</span>
          </div>
        </el-header>
      <el-main>
        <router-view :userid="userid" :username="username" :realname="name" :companyID="companyID" :usercompany="usercompany"/>
      </el-main>
      <el-footer>
          <el-text style="font-size: 12px">
            © {{ $t('login.copyRight', { msg: 'login.copyRight' })  }}1999 - {{ year }}{{ $t('login.compass', { msg: 'login.compass' })  }}
            <br><a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备17010737号</a></el-text>
      </el-footer>
    </el-container>

  </el-container>
</el-config-provider>
</template>

<script>
import { getusercompany } from '../axios';
import axios from 'axios';
import { baseUrl_New } from '../axios/urlconfig';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { getRequest } from '../axios/axios';
export default {
  data() {
    return {
      language: '',
      allusercompany: [],
      agent: [],
      username: '',
      userid: '',
      name: '',
      role: '',
      companyID: '',
      usercompany: '',
      year:'',
      agentNone: false,
      isPass: 0,
    }
  },
  created() {
    this.getRouterData();
    this.queryAgent();
    this.nowYear();
    this.init();
    this.confirmReviewer();
  },

  computed: {
    locale() {
      return this.language === 'zh-cn' ? zhCn : en;
    } 
  },

  methods: {
    init(){
      this.language = localStorage.getItem("language");
      // console.log(this.language);
    },
    getUserCompany(){ //获得用户的公司信息
      getusercompany({
        companyID: this.companyID
      }).then(res=>{
        this.allusercompany.splice(0,this.allusercompany.length);
        for (let i=0 ;i<res.count;i++){
          this.allusercompany.push({text: res.data[i].companyID});
        }
        this.allusercompany.sort(function(a,b){return a.label>b.label ? 1:-1;}); //将公司根据公司名排序
      }).catch(err=>{
        console.log(err);
      });
    },
    getRouterData() {  //获得登录数据
      this.username = this.$route.params.username;
      this.userid = this.$route.params.userid;
      this.name = this.$route.params.name;
      if(this.username == undefined || this.userid == undefined || this.name == undefined){
        this.username = sessionStorage.getItem('username');
        this.userid = sessionStorage.getItem('userid');
        this.name = sessionStorage.getItem('name');
      }
      if(this.companyID == ''){
        this.companyID = sessionStorage.getItem('companyID');
      }
      if(this.usercompany == ''){
        this.usercompany = JSON.parse(sessionStorage.getItem('usercompany'));
      }
      if(this.role == ''){
        this.role = sessionStorage.getItem('role');
      }
    },
    handleCommand(command) { //处理下拉菜单选择事件
      if(command == "退出登录"){
        this.$confirm(this.$t('login.loginInfo', { msg: 'login.loginInfo' }) + sessionStorage.getItem("username") + this.$t('login.account', { msg: 'login.account' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
        confirmButtonText: this.$t('login.yes', { msg: 'login.no' }),
        cancelButtonText: this.$t('login.no', { msg: 'login.no' }),
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
        }).then(() => {
        getRequest(baseUrl_New + '/logout')
        .then(res => {
          console.log(res);
          this.$router.push('/login');
          this.$message.success(sessionStorage.getItem('username') + ' ' + this.$t('login.logoutS', { msg: 'login.logoutS' }) + '!');
          sessionStorage.clear();
          localStorage.clear();
        })
      })
      }else if(command == '个人主页'){
        this.$router.push('/mainpage')
      }else if(command == '申请用户'){
        this.$router.push('/applyoutsider')
      }
    },

    queryAgent() {
      // 发起GET请求
      getRequest(baseUrl_New + '/agent/querylogo', {
          companyId: this.companyID
      })
      .then(response => {
        // console.log(response);
        for(let i = 0;i < response.length;i++){
        this.agent.push({
          name: response[i].agentName,
          logo: response[i].agentLogo
        })
      }
      if(response.length === 0){
        this.agentNone = true;
      }
      })
      .catch(error => {
        // 请求失败处理
        console.error(error);
      });
    },

    confirmReviewer(){
      const userId = sessionStorage.getItem('userid');
      getRequest(baseUrl_New+'/kb/confirm?userId='+userId).then(response=>{
            let resultMap = response.data;
            this.isPass = resultMap.isPass || 0;
            
          })
    },
    
    nowYear(){
      let nowDate = new Date();
      let date = {
      // 获取当前年份
      yearNow: nowDate.getFullYear(),
      };
      this.year=date.yearNow;
    },

  }
};
</script>

<style>
.el-header {
  /* background-color: #B3C0D1; */
  background-color: rgb(255, 255, 255);
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}
#particles-js{
  width: 100%;
  height: calc(100% - 100px);
  position: absolute;
}
.el-menu-item {
  text-align: left;
  width: auto;
}
.el-sub-menu {
  text-align: left;
  width: auto;
}
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.left-aligned-image {
  position: absolute;
  width: 120px;
  height: 60px;
  margin-left: 0px; /* 水平居左 */
}

</style>
